function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgView(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22 17"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, React.createElement("path", {
    d: "M20.89,6.75a2.82,2.82,0,0,1,0,3.5C19,12.6,15.3,16.5,11,16.5s-8-3.9-9.89-6.25a2.82,2.82,0,0,1,0-3.5C3,4.4,6.7.5,11,.5S19,4.4,20.89,6.75Z",
    style: {
      fill: "none",
      stroke: "#5b606b",
      strokeMiterlimit: 10
    }
  }), React.createElement("circle", {
    cx: 11,
    cy: 8.56,
    r: 4.55,
    style: {
      fill: "none",
      stroke: "#5b606b",
      strokeMiterlimit: 10
    }
  }))));
}

export default __webpack_public_path__ + "static/media/view.d4276153.svg";
export { SvgView as ReactComponent };